export const getCurrencyFormatter = (culture: string, currency: string) => {
  try {
    return new Intl.NumberFormat(culture, {
      style: 'currency',
      currency: currency,
    });
  } catch {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
};

export const getCurrencyParts = (formatter: Intl.NumberFormat, value: number) => {
  try {
    return formatter.formatToParts(value);
  } catch {
    return [];
  }
};
